import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { calculateTaxDeduction } from '@/app/donation/guide/utils';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
const FULL_TAX_DEDUCTION_LIMIT = 100000;
interface PriceInfoProps {
  amount: number;
}
export const PriceInfo = t0 => {
  const $ = _c(30);
  const {
    amount
  } = t0;
  const isKakaobank = useCheckKakaobank();
  const isFullTaxDeduction = amount <= FULL_TAX_DEDUCTION_LIMIT;
  if (!isFullTaxDeduction || isKakaobank) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = cn("font-700 text-Gray-900 typo-h3", "tablet:typo-h5", "mobile:typo-h5");
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== amount) {
      t2 = amount.toLocaleString();
      $[1] = amount;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <p className={t1}>{t2}원</p>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = cn("font-500 text-B-500 typo-body3", "tablet:typo-body4", "mobile:typo-body4");
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== amount || $[7] !== isFullTaxDeduction) {
      t5 = isFullTaxDeduction ? `세액공제로 ${amount.toLocaleString()}원 모두 돌려받아요` : `세액공제로 ${calculateTaxDeduction(amount).total.toLocaleString()}원 돌려받아요`;
      $[6] = amount;
      $[7] = isFullTaxDeduction;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t5) {
      t6 = <p className={t4}>{t5}</p>;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== t3 || $[12] !== t6) {
      t7 = <div>{t3}{t6}</div>;
      $[11] = t3;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  }
  let t1;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("font-700 text-Gray-550 line-through typo-body1", "tablet:typo-body2", "mobile:typo-body2");
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[15] !== amount) {
    t2 = amount.toLocaleString();
    $[15] = amount;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== t2) {
    t3 = <span className={t1}>{t2}원</span>;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={cn("font-700 text-O-400 typo-h3", "tablet:typo-h5", "mobile:typo-h5")}>0원</span>;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t3) {
    t5 = <div className="flex items-center gap-8">{t3}{t4}</div>;
    $[20] = t3;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("font-500 text-B-500 typo-body3", "tablet:typo-body4", "mobile:typo-body4");
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== amount) {
    t7 = amount.toLocaleString();
    $[23] = amount;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t7) {
    t8 = <p className={t6}>세액공제로 {t7}원 모두 돌려받아요</p>;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t5 || $[28] !== t8) {
    t9 = <div>{t5}{t8}</div>;
    $[27] = t5;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
};